<template lang="pug">
div
  md-layout
    md-switch.md-primary(v-model='ads.banner.enabled') Use Banner Image
  md-layout(v-if='ads.banner.enabled')
    md-input-container(:class='{ "md-input-invalid" : formSubmitted && validations.banner.image.$invalid }')
      label Image URL
      md-input(v-model='ads.banner.image')
      span.md-error(v-if='formSubmitted && validations.banner.image.$invalid') Invalid URL
    md-input-container(:class='{ "md-input-invalid" : formSubmitted && validations.banner.link.$invalid }')
      label Link URL
      md-input(v-model='ads.banner.link')
      span.md-error(v-if='formSubmitted && validations.banner.link.$invalid') Invalid URL
</template>

<script>
  export default {
    props: {
      ads: {
        type: Object,
        required: true
      },
      platforms: {
        type: Object,
        required: true
      },
      validations: {
        type: Object,
        required: true
      },
      formSubmitted: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      };
    },
    components: {
    },
    computed: {
    },
    methods: {
    },
    watch: {
    }
  };
</script>



// WEBPACK FOOTER //
// src/shared-components/ImageBanner.vue